import { Immer } from "immer";
import { immer } from "zustand/middleware/immer";

interface ReadyToBillState {
  readyToBill: {
    products: Array<Record<string, any>>;
    expenses: Array<Record<string, any>>;
    timeEntries: Array<Record<string, any>>;
    contracts: Array<Record<string, any>>;
    totalItems: number;
    customerId: string;
    services: Array<Record<string, any>>;
  };
}

interface ReadyToBillAction {
  setReadyToBillData: ({
    products,
    expenses,
    timeEntries,
    services,
    contracts,
    customerId,
  }: {
    products: Array<Record<string, any>>;
    expenses: Array<Record<string, any>>;
    timeEntries: Array<Record<string, any>>;
    services: Array<Record<string, any>>;
    contracts: Array<Record<string, any>>;
    customerId: string;
  }) => void;
}

export interface ReadyToBillStateActionInterface
  extends ReadyToBillAction,
    ReadyToBillState {}

export const readyToBillSlice = immer<ReadyToBillState & ReadyToBillAction>(
  (set, get) => ({
    readyToBill: {
      products: [],
      expenses: [],
      timeEntries: [],
      services: [],
      contracts: [],
      totalItems: 0,
      customerId: "",
    },

    setReadyToBillData: (data: {
      products: Array<Record<string, any>>;
      expenses: Array<Record<string, any>>;
      timeEntries: Array<Record<string, any>>;
      services: Array<Record<string, any>>;
      contracts: Array<Record<string, any>>;
      customerId: string;
    }) =>
      set((state) => {
        state.readyToBill = {
          ...data,
          totalItems:
            data.products.length +
            data.expenses.length +
            data.timeEntries.length,
        };
      }),
  })
);
